import moment from "moment";
import { isPresent } from 'utils/isPresent';
import React from 'react';
import { createSelector } from 'reselect';
import { v4 as uuidv4 } from 'uuid';
import TasksApi from './Api/TasksApi';
import {
  receivedServerData,
  undoLastChange,
  updateCache,
  updateCacheWithReversibleChange,
} from '../../Common/Data/DataFetcher';
import { isBlank } from 'utils/isBlank';

const TASKS_NAMESPACE = 'tasks';

const getTasks = (state, props = {}) => {
  const tasksFromServer = state.tasks || {};
  const { pro } = state;

  let tasksList;
  const tasks = Object.values(tasksFromServer);

  if (props.showMyTasks) {
    tasksList = tasks.filter((task) => (isPresent(task.service_pro) && task.service_pro.uuid === pro.id));
  } else {
    tasksList = tasks;
  }
  return tasksList;
};

export const unarchivedTasks = createSelector(
  getTasks,
  (tasks) => tasks.filter((task) => task.archived !== true),
);

export const getNonCompletedTasksList = createSelector(
  unarchivedTasks,
  (tasks) => tasks.filter((task) => (!task.completed)),
);

export const getCompletedTasksList = createSelector(
  unarchivedTasks,
  (tasks) => tasks.filter((task) => task.completed === true).sort(sortByUpdatedAt),
);

export const getNoDateTasks = createSelector(
  getNonCompletedTasksList,
  (tasks) => tasks.filter((task) => task.due === null || task.due === undefined).sort(sortByUpdatedAt),
);

export const getPastDueTasks = createSelector(
  getNonCompletedTasksList,
  (tasks) => (tasks.filter((task) => (
    isPresent(task.due) && moment(task.due).isBefore(today())
  ))).sort(sortByDueDate),
);

export const getTodayTasks = createSelector(
  getNonCompletedTasksList,
  (tasks) => tasks.filter((task) => (
    isPresent(task.due) && moment(task.due).isSame(today())
  )),
);

export const getTomorrowTasks = createSelector(
  getNonCompletedTasksList,
  (tasks) => tasks.filter((task) => (
    isPresent(task.due) && moment(task.due).isSame(tomorrow())
  )),
);

export const getUpcomingTasks = createSelector(
  getNonCompletedTasksList,
  (tasks) => (tasks.filter((task) => (
    isPresent(task.due) && moment(task.due).isAfter(tomorrow())
  ))).sort(sortByDueDateDesc),
);

export const fetchTasksList = {
  fetchingApiFunc: TasksApi.show,
  selector: getTasks,
  paramsFromProps: () => [],
  dataNamespace: TASKS_NAMESPACE,
};

export function receivedTasks(data) {
  return receivedServerData(data, TASKS_NAMESPACE);
}

export function undoTaskChange(dispatch, getState) {
  const previousTask = undoLastChange(TASKS_NAMESPACE, dispatch, getState);

  updateCache(previousTask.id, previousTask, TASKS_NAMESPACE, dispatch, getState());

  return previousTask;
}

export function updateTaskInCache(id, updatedFields, dispatch, state) {
  const task = updatedFields;

  if (isBlank(id)) {
    id = uuidv4();
    task.id = id;
  }

  task.updated_at = new Date();

  return updateCacheWithReversibleChange(id, updatedFields, TASKS_NAMESPACE, dispatch, state);
}

function today() {
  return moment(moment(new Date()).format('YYYY-MM-DD'));
}

function tomorrow() {
  return moment(moment(new Date()).add(1, 'days').format('YYYY-MM-DD'));
}

function sortByDueDate(a, b) {
  const dateA = moment(a.due);
  const dateB = moment(b.due);

  let comparison = 0;
  if ((dateA).isAfter(dateB)) {
    comparison = 1;
  } else if ((dateA).isBefore(dateB)) {
    comparison = -1;
  }
  return comparison;
}

function sortByDueDateDesc(b, a) {
  const dateA = moment(a.due);
  const dateB = moment(b.due);

  let comparison = 0;
  if ((dateB).isAfter(dateA)) {
    comparison = 1;
  } else if ((dateB).isBefore(dateA)) {
    comparison = -1;
  }

  return comparison;
}

function sortByUpdatedAt(b, a) {
  const dateA = moment(a.updated_at);
  const dateB = moment(b.updated_at);

  let comparison = 0;
  if ((dateB).isAfter(dateA)) {
    comparison = -1;
  } else if ((dateB).isBefore(dateA)) {
    comparison = 1;
  }

  return comparison;
}
